/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination, RequestParams } from '~core/models/core.models';
import { CreateUnitMeasureParams, UnitMeasure } from '~core/models/core.models';
import { UNIT_MEASURE_URL } from '../constants/api.constants';

@Injectable()
export class UnitMeasureService {
  private _httpClient = inject(HttpClient);

  read(userId: string): Observable<UnitMeasure> {
    return this._httpClient.get<UnitMeasure>(`${UNIT_MEASURE_URL}/${userId}`);
  }

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<UnitMeasure>> {
    return this._httpClient.get<Pagination<UnitMeasure>>(UNIT_MEASURE_URL, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateUnitMeasureParams): Observable<UnitMeasure> {
    return this._httpClient.post<UnitMeasure>(UNIT_MEASURE_URL, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    data: Partial<CreateUnitMeasureParams>
  ): Observable<UnitMeasure> {
    return this._httpClient.patch<UnitMeasure>(`${UNIT_MEASURE_URL}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  delete(unitMeasureId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${UNIT_MEASURE_URL}/${unitMeasureId}`
    );
  }
}
